module.exports = __webpack_public_path__ + "static/favicon_edm-119bca437c5cd3a14d770213f111c773.png";